import type { IconData } from '@stacksjs/iconify-core'

export const ruler: IconData = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" stroke-width=\"3\" d=\"M43.622 15.766c1.616 2.029 1.48 4.828-.282 6.73c-1.974 2.131-5.182 5.488-10.269 10.575s-8.444 8.295-10.574 10.269c-1.903 1.762-4.702 1.898-6.73.282a73 73 0 0 1-6.03-5.359a73 73 0 0 1-5.36-6.03c-1.615-2.028-1.479-4.827.283-6.73c1.973-2.13 5.182-5.488 10.269-10.574c5.086-5.087 8.443-8.296 10.574-10.269c1.903-1.762 4.702-1.898 6.73-.282a73 73 0 0 1 6.03 5.358a73 73 0 0 1 5.36 6.03m-27.452 6.199l-4.062-4.062m-1.866 10.134L6.206 24m16.037-7.963l-4.132-4.132m9.783-2.016l-3.757-3.757\"/>",
  "width": 48,
  "height": 48,
  "viewBox": "0 0 48 48"
}

export default ruler
